<template>
    <PublicProfileLayout>
        <div class="overflow-x-hidden">
            <section class="text-center py-6 px-4 md:px-6 bg-faded">
                <h1 class="H5-SemiBold text-primary mb-2">PRIVACY POLICY</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <PrivacyPolicyContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded" id="cookie-policy">
                <h1 class="H5-SemiBold text-primary mb-2">COOKIE POLICY</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>
            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <CookiePolicyContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded" id="refund-policy">
                <h1 class="H5-SemiBold text-primary mb-2">REFUND POLICY</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>
            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <RefundPolicyContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded" id="ai-governance">
                <h1 class="H5-SemiBold text-primary mb-2">AI USAGE, ETHICS & GOVERNANCE POLICY</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <AIPolicyContent />
            </section>

            <section class="text-center py-6 px-4 md:px-6 bg-faded" id="child-protection">
                <h1 class="H5-SemiBold text-primary mb-2">CHILD PROTECTION & SAFEGUARDING POLICY</h1>
                <p class="Label text-500 uppercase tracking-wider">
                    Jurisdiction: Democratic Socialist Republic of Sri Lanka
                </p>
            </section>

            <section class="py-6 px-4 md:px-6 max-w-custom mx-auto">
                <SafeguardingPolicyContent />
            </section>
        </div>
    </PublicProfileLayout>
</template>

<script setup>
import PublicProfileLayout from "@/layout/PublicProfileLayout.vue";
import PrivacyPolicyContent from "@/components/legal/PrivacyPolicyContent.vue"; 
import CookiePolicyContent from "@/components/legal/CookiePolicyContent.vue";
import RefundPolicyContent from "@/components/legal/RefundPolicyContent.vue";
import AIPolicyContent from "@/components/legal/AIPolicyContent.vue";
import SafeguardingPolicyContent from "@/components/legal/SafeguardingPolicyContent.vue";
</script>

<style scoped>
.LandingPage-Title { color: #1D97BD; }
.bg-faded { background-color: rgba(29, 151, 189, 0.04); }
.max-w-custom { max-width: 900px; }
</style>